"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _excluded = ["orientation", "className", "style", "thickness", "jss"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _createStyles["default"])(function (theme) {
  return {
    horizontal: {
      width: '100%',
      borderTop: 'solid'
    },
    vertical: {
      height: '100%',
      borderLeft: 'solid'
    },
    root: {
      borderWidth: function borderWidth(_ref) {
        var thickness = _ref.thickness;
        return thickness || 1;
      },
      borderColor: theme.palette.border
    }
  };
}, {
  name: 'Divider'
});
exports.useStyles = useStyles;
var Divider = /*#__PURE__*/(0, _react.forwardRef)(function Divider(_ref2, ref) {
  var _cn;

  var orientation = _ref2.orientation,
      className = _ref2.className,
      style = _ref2.style,
      thickness = _ref2.thickness,
      jss = _ref2.jss,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var classes = useStyles({
    thickness: thickness,
    jss: jss
  });
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref
  }, props, {
    className: (0, _classnames["default"])(classes.root, (_cn = {}, (0, _defineProperty2["default"])(_cn, classes.horizontal, orientation === 'horizontal'), (0, _defineProperty2["default"])(_cn, classes.vertical, orientation === 'vertical'), _cn), className),
    style: style
  }));
});
Divider.defaultProps = {
  orientation: 'horizontal',
  className: '',
  style: {},
  thickness: 1
};
Divider.propTypes = {
  /** Orientation of divider - values = ['horizontal', 'vertical'] - when vertical, provide height for the component */
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']),

  /** Set additional class names to divider */
  className: _propTypes["default"].string,

  /** Set style to divider */
  style: _propTypes["default"].shape(),

  /** Border width */
  thickness: _propTypes["default"].number
};
Divider.displayName = 'Divider';
var _default = Divider;
exports["default"] = _default;